/**
 * Desktop - Footer organism
 */

import GlobalVars from '../../common/GlobalVars';
import {
  debounce,
  inViewport
} from '../../common/Utils';

function loadFooterReassurances() {
  const ReassuranceItem = ({ title, content }) => `
    <div class="o-flexcontent__block m-reassurance">
        <div class="m-reassurance__title a-title">${title}</div>
        <div>${content}</div>
    </div>
  `;

  if (inViewport($('#footer-reassurance'))) {
    if (!$('#footer-reassurance').attr('loaded')) {
      $('#footer-reassurance').attr('loaded', true);

      $.get(`${document.location.origin}/api/MasterPageComponents/Reassurances/Desktop/${GlobalVars.Brand.toUpperCase()}/${GlobalVars.C}/${GlobalVars.L}`)
       .then(footerReassurances => $('#footer-reassurance')
            .html(footerReassurances.map(reassurance => ReassuranceItem({ title: reassurance.Title, content: reassurance.Content })))
            .css('display', 'flex')
            .fadeIn());
    }
  }
}

function loadFooterLinks() {
  const FooterLinksItem = ({ title, content }) => `
    <div class="o-flexcontent__block m-footerlink">
        <div class="m-footerlink__title a-title">${title}</div>
        <div>${content}</div>
    </div>
  `;

  if (inViewport($('#footer-links'))) {
    if (!$('#footer-links').attr('loaded')) {
      $('#footer-links').attr('loaded', true);

      $.get(`/api/MasterPageComponents/FooterBlocs/Desktop/${GlobalVars.Brand.toUpperCase()}/${GlobalVars.C}/${GlobalVars.L}`)
      .then(footerLinks =>
        $('#footer-links')
        .html(
          footerLinks
          .map(link => FooterLinksItem({ title: link.Title, content: link.Content }))
        )
        .css('display', 'flex')
        .fadeIn()
      );
    }
  }
}

const delayedLoading = debounce(() => {
  loadFooterReassurances();
  loadFooterLinks();
}, 300);

function init() {
  $(document).ready(() => {
    if ($('.js-footer').length) {
      $(window).on('scroll', delayedLoading);
    }
  });
}

export {
  init,
};

export default init;



// WEBPACK FOOTER //
// ./js/desktop/organism/footer.js